import { isObject, isArray } from 'lodash'

export const convertBlockReplyInTable = blockReply => {
  const obj = blockReply.value.map(item => {
    const result = item.map(item => {
      let value = typeof item.value === 'boolean' ? (item?.value ? 'Sim' : 'Não') : item.value
      value = isArray(value) ? value.map(value => value?.name).join(', ') : value
      value = isObject(value) ? value.name : value
      return { [item.question.name]: value }
    })
    return [...result]
  })

  const allKeys = [...new Set(obj.flat().flatMap(obj => Object.keys(obj)))]

  return obj.map(group => {
    const baseObject = Object.fromEntries(allKeys.map(key => [key, '']))
    const filledObject = group.reduce((acc, obj) => ({ ...acc, ...obj }), baseObject)

    return [filledObject]
  })
}

export const TAXA_METABOLICA = {
  'Sentado - Em repouso': 100,
  'Sentado - Trabalho leve com as mãos': 126,
  'Sentado - Trabalho moderado com as mãos': 153,
  'Sentado - Trabalho pesado com as mãos': 171,
  'Sentado - Trabalho leve com um braço': 162,
  'Sentado - Trabalho moderado com um braço': 198,
  'Sentado - Trabalho pesado com um braço': 234,
  'Sentado - Trabalho leve com dois braços': 216,
  'Sentado - Trabalho moderado com dois braços': 252,
  'Sentado - Trabalho pesado com dois braços': 288,
  'Sentado - Trabalho leve com braços e pernas': 324,
  'Sentado - Trabalho moderado com braços e pernas': 441,
  'Sentado - Trabalho pesado com braços e pernas': 603,
  'Em pé, agachado ou ajoelhado - Em repouso': 126,
  'Em pé, agachado ou ajoelhado - Trabalho leve com as mãos': 153,
  'Em pé, agachado ou ajoelhado - Trabalho moderado com as mãos': 180,
  'Em pé, agachado ou ajoelhado - Trabalho pesado com as mãos': 198,
  'Em pé, agachado ou ajoelhado - Trabalho leve com um braço': 189,
  'Em pé, agachado ou ajoelhado - Trabalho moderado com um braço': 225,
  'Em pé, agachado ou ajoelhado - Trabalho pesado com um braço': 261,
  'Em pé, agachado ou ajoelhado - Trabalho leve com dois braços': 243,
  'Em pé, agachado ou ajoelhado - Trabalho moderado com dois braços': 279,
  'Em pé, agachado ou ajoelhado - Trabalho pesado com dois braços': 315,
  'Em pé, agachado ou ajoelhado - Trabalho leve com o corpo': 351,
  'Em pé, agachado ou ajoelhado - Trabalho moderado com o corpo': 468,
  'Em pé, agachado ou ajoelhado - Trabalho pesado com o corpo': 630,
  'Em pé, em movimento - Andando no plano - Sem carga - 2 km/h': 198,
  'Em pé, em movimento - Andando no plano - Sem carga - 3 km/h': 252,
  'Em pé, em movimento - Andando no plano - Sem carga - 4 km/h': 297,
  'Em pé, em movimento - Andando no plano - Sem carga - 5 km/h': 360,
  'Em pé, em movimento - Andando no plano - Com carga - 10 kg, 4 km/h': 333,
  'Em pé, em movimento - Andando no plano - Com carga - 30 kg, 4 km/h': 450,
  'Em pé, em movimento Correndo no plano - 9 km/h': 787,
  'Em pé, em movimento - Andando no plano - Com carga - 12 km/h': 873,
  'Em pé, em movimento - Andando no plano - Com carga - 15 km/h': 990,
  'Em pé, em movimento - Subindo rampa - Sem carga - com 5° de inclinação, 4 km/h': 324,
  'Em pé, em movimento - Subindo rampa - Sem carga - com 15° de inclinação, 3 km/h': 378,
  'Em pé, em movimento - Subindo rampa - Sem carga - com 25° de inclinação, 3 km/h': 540,
  'Em pé, em movimento - Subindo rampa - Com carga de 20 kg - com 15° de inclinação, 4 km/h': 486,
  'Em pé, em movimento - Subindo rampa - Com carga de 20 kg - com 25° de inclinação, 4 km/h': 738,
  'Em pé, em movimento - Descendo rampa (5 km/h) sem carga - com 5° de inclinação': 243,
  'Em pé, em movimento - Descendo rampa (5 km/h) sem carga - com 15° de inclinação': 252,
  'Em pé, em movimento - Descendo rampa (5 km/h) sem carga - com 25° de inclinação': 324,
  'Em pé, em movimento - Subindo escada (80 degraus por minuto – altura do degrau de 0,17 m) - Sem carga': 522,
  'Em pé, em movimento - Subindo escada (80 degraus por minuto – altura do degrau de 0,17 m) - Com carga (20 kg)': 648,
  'Em pé, em movimento - Descendo escada (80 degraus por minuto – altura do degrau de 0,17 m) - Sem carga': 279,
  'Em pé, em movimento - Descendo escada (80 degraus por minuto – altura do degrau de 0,17 m) - Com carga (20 kg)': 400,
  'Em pé, em movimento - Trabalho moderado de braços (ex.: varrer, trabalho em almoxarifado)': 320,
  'Em pé, em movimento - Trabalho moderado de levantar ou empurrar': 349,
  'Em pé, em movimento - Trabalho de empurrar carrinhos de mão, no mesmo plano, com carga': 391,
  'Em pé, em movimento - Trabalho de carregar pesos ou com movimentos vigorosos com os braços (ex.: trabalho com foice)': 495,
  'Em pé, em movimento - Trabalho pesado de levantar, empurrar ou arrastar pesos (ex.: remoção com pá, abertura de valas)': 524
}
